/** SPA paths that must work without Keycloak login (US-400 / US-403 / supplier / collaborator). */
const PUBLIC_PATH_PATTERNS: RegExp[] = [
  /^\/$/,
  /^\/welcome\/?$/,
  /^\/share\/[^/]+\/?$/,
  /^\/supplier\/[^/]+\/?$/,
  /^\/collaborator\/[^/]+\/?$/,
];

export function isPublicPath(pathname: string = typeof window !== "undefined" ? window.location.pathname : "/"): boolean {
  return PUBLIC_PATH_PATTERNS.some((re) => re.test(pathname));
}
